import { useEffect, useState } from 'react'
import useKrpano from './krpano/useKrpano'
import { useToggle } from 'react-use'

const useDemoKrpano = (
  {default_embedding_params: tour, 
    krpano_script_path: scriptPath,
    target_id : target_ID,
    global_var_name : varName} = {}) => {
  const [showLoadingPage, setShowLoadingPage] = useState(true)
  const [isLocked, toggleLockView] = useToggle(false)
  const [isHideSpots, toggleHideSpots] = useToggle(false)
  const [currentScene, setCurrentScene] = useState('')
  const {
    containerRef,
    krpanoState: { isLoaded },
    getKrpano,
    setKrpano,
    lockView,
    unlockView,
    callKrpano,
  } = useKrpano({
    globalFunctions: {
      logScene: (scene) => {
        setCurrentScene(scene)
      },
    },
    default_embedding_params : tour,
    scriptPath : scriptPath,
    targetID : target_ID,
    globalVarName : varName
  })

  // Debounce hide loading page
  useEffect(() => {
    if (isLoaded) {
      setTimeout(() => {
        setShowLoadingPage(false)
      }, 1000)
    }
  }, [isLoaded])

  useEffect(() => {
    
    if (!isLoaded) return

    if (isLocked) {
      lockView()
    } else {
      unlockView()
    }
  }, [isLocked]) // eslint-disable-line

  useEffect(() => {
    if (!isLoaded) return

    if (isHideSpots) {
      callKrpano('toggleHotspotVisibility(0)')
    } else {
      callKrpano('toggleHotspotVisibility(1)')
    }
  }, [isHideSpots]) // eslint-disable-line

  return {
    showLoadingPage,
    isLoaded,
    containerRef,
    toggleLockView,
    isLocked,
    toggleHideSpots,
    isHideSpots,
    currentScene,
    getKrpano,
    setKrpano,
  }
}

export default useDemoKrpano